<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.83333 10C2.5 10 2.5 11.4917 2.5 13.3333V14.1667C2.5 16.4667 2.5 18.3333 6.66667 18.3333H13.3333C16.6667 18.3333 17.5 16.4667 17.5 14.1667V13.3333C17.5 11.4917 17.5 10 14.1667 10C13.3333 10 13.1 10.175 12.6667 10.5L11.8167 11.4C10.8333 12.45 9.16667 12.45 8.175 11.4L7.33333 10.5C6.9 10.175 6.66667 10 5.83333 10Z" stroke="url(#paint0_linear_8764_18734)" stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M15.8337 10.0001V5.00008C15.8337 3.15841 15.8337 1.66675 12.5003 1.66675H7.50033C4.16699 1.66675 4.16699 3.15841 4.16699 5.00008V10.0001" stroke="url(#paint1_linear_8764_18734)" stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M8.79199 7.69165H11.567" stroke="url(#paint2_linear_8764_18734)" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M8.09961 5.19165H12.2663" stroke="url(#paint3_linear_8764_18734)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <defs>
      <linearGradient id="paint0_linear_8764_18734" x1="0.112456" y1="2.99769" x2="23.1912" y2="10.5229" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FECBD4" />
        <stop offset="0.345047" stop-color="#EB008B" stop-opacity="0.8" />
        <stop offset="0.857321" stop-color="#AA0085" stop-opacity="0.85" />
        <stop offset="1" stop-color="#8A008A" />
      </linearGradient>
      <linearGradient id="paint1_linear_8764_18734" x1="2.31001" y1="-5.33556" x2="20.9686" y2="-0.603591" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FECBD4" />
        <stop offset="0.345047" stop-color="#EB008B" stop-opacity="0.8" />
        <stop offset="0.857321" stop-color="#AA0085" stop-opacity="0.85" />
        <stop offset="1" stop-color="#8A008A" />
      </linearGradient>
      <linearGradient id="paint2_linear_8764_18734" x1="8.3503" y1="6.85137" x2="12.121" y2="8.74685" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FECBD4" />
        <stop offset="0.345047" stop-color="#EB008B" stop-opacity="0.8" />
        <stop offset="0.857321" stop-color="#AA0085" stop-opacity="0.85" />
        <stop offset="1" stop-color="#8A008A" />
      </linearGradient>
      <linearGradient id="paint3_linear_8764_18734" x1="7.4364" y1="4.35137" x2="11.9547" y2="7.76172" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FECBD4" />
        <stop offset="0.345047" stop-color="#EB008B" stop-opacity="0.8" />
        <stop offset="0.857321" stop-color="#AA0085" stop-opacity="0.85" />
        <stop offset="1" stop-color="#8A008A" />
      </linearGradient>
    </defs>
  </svg>
</template>
